(() => {
  const modal = document.getElementById('ksCountryModal');
  if (!modal) return;

  const grid = document.getElementById('ksCountryModalGrid');
  const title = document.getElementById('ksCountryModalTitle');
  const cta = document.getElementById('ksCountryModalCta');

  // Base URL to Shopify Files folder (comes from data-files-base on the modal wrapper)
  const filesBase = (modal.getAttribute('data-files-base') || '').trim();

  const handleize = (str) => {
    return (str || '')
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '') // remove accents
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  };

  const escapeHtml = (s) => {
    return (s || '').replace(/[&<>"']/g, (m) => (
      { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]
    ));
  };

  const openModal = () => {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  };

  const closeModal = () => {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  };

  // Close: backdrop + X button (anything with data-ks-close)
  modal.addEventListener('click', (e) => {
    if (e.target.closest('[data-ks-close]')) {
      e.preventDefault();
      closeModal();
    }
  });

  // Close: ESC
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });

  // Open + build list
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('.ks-country-trigger');
    if (!trigger) return;

    // Stop Horizon product-card link layer from hijacking the click
    e.preventDefault();
    e.stopPropagation();

    const targetId = trigger.getAttribute('data-countries-target');
    const productTitle = trigger.getAttribute('data-title') || 'Countries Covered';
    const productUrl = trigger.getAttribute('data-url') || '#';

    const holder = document.getElementById(targetId);
    if (!holder || !grid || !title || !cta) return;

    // holder contains HTML from metafield_tag (usually <ul><li>Country</li>...</ul>)
    const items = holder.querySelectorAll('li');
    const countries = Array.from(items)
      .map(li => (li.textContent || '').trim())
      .filter(Boolean);

    title.textContent = productTitle;
    cta.href = productUrl;

    grid.innerHTML = countries.map((name) => {
      const safeName = escapeHtml(name);

      // Build flag URL: filesBase + handleized-country + .png
      let flagHtml = '';
      if (filesBase) {
        const filename = `${handleize(name)}.png`;
        const src = `${filesBase}${filename}`;
        flagHtml = `
          <img class="ks-cmodal__flag"
               src="${src}"
               alt=""
               width="30"
               height="20"
               loading="lazy"
               onerror="this.remove()">
        `;
      }

      return `<div class="ks-cmodal__item">${flagHtml}<span>${safeName}</span></div>`;
    }).join('');

    openModal();
  });
})();